<template>
  <h5 id="serp__filters-header" class="q-px-3 q-fs-5 q-my-2 q-fw-semibold">
    {{ SmartSearchTranslations.filters.header }}
  </h5>
</template>

<script setup lang="ts">
import {inject} from "vue";
import {SmartSearchTranslationsInterface} from "@/core/types";
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!
</script>
